<template>
  <topbar
    :titulo="$t('ACADEMICO.RELATORIOS_TURMAS')"
    :subtitulo="$t('ACADEMICO.RELATORIO_TURMAS_DESCRICAO')"
    :breadcrumbs="breadcrumbs"
  />
</template>
<script>
import Topbar from '@/layouts/full-layout/horizontal-sidebar/Topbar.vue';

export default {
  components: { Topbar },
  data() {
    return {
      breadcrumbs: [
        { titulo: this.$t('ACADEMICO.ACADEMICO') },
        { titulo: this.$t('ACADEMICO.RELATORIOS') },
        { titulo: this.$t('ACADEMICO.RELATORIOS_TURMAS') },
      ],
    };
  },
  methods: {},
};
</script>
